import axios from 'axios'
import type { AxiosInstance } from 'axios'
import type { RequestConfig } from './type'

import { Msg } from '@/utils/acro-methods'

// import fullLoading from '@/components/comm/full-loading/full-loading.ts'

import useUserStore from '@/store/user'

class MyRequest {
  instance: AxiosInstance

  // request实例 => axios的实例
  constructor(config: RequestConfig) {
    this.instance = axios.create(config)
    // 每个instance实例都添加拦截器
    this.instance.interceptors.request.use(
      (config: any) => {
        // if (!config?.isCloseFullLoading) {
        //   fullLoading?.open?.()
        // }
        return config
      },
      err => {
        // fullLoading?.close?.()
        return err
      }
    )
    this.instance.interceptors.response.use(
      res => {
        // fullLoading?.close?.()
        const { status, data } = res
        const message = data?.msg

        if (status == 200 && (data?.code == 0 || toString.call(data) === '[object Blob]')) {
          return data
        } else {
          if (data?.code == '401') {
            useUserStore().actionLogout()
            window.location.pathname = '/login'
          } else {
            Msg.error(message)
            return Promise.reject(message)
          }
        }
      },
      err => {
        // fullLoading?.close?.()
        const { status, data } = err?.response ?? {}
        if (!status) return Msg.error('连接超时，请稍后尝试~')
        if (status != 200) {
          const message = data.msg || err?.msg || err

          Msg.error(message)
          return Promise.reject(message)
        }
      }
    )

    // 针对特定的Request实例添加拦截器
    this.instance.interceptors.request.use(config?.interceptors?.requestSuccessFn, config.interceptors?.requestFailureFn)
    this.instance.interceptors.response.use(config.interceptors?.responseSuccessFn, config.interceptors?.responseFailureFn)
  }

  // 封装网络请求的方法
  // T => IHomeData
  request<T = any>(config: RequestConfig<T>) {
    // 单次请求的成功拦截处理
    if (config.interceptors?.requestSuccessFn) {
      config = config.interceptors.requestSuccessFn(config)
    }

    // 返回Promise
    return new Promise<T>((resolve, reject) => {
      this.instance
        .request<any, T>(config)
        .then(res => {
          // 单词响应的成功拦截处理
          if (config?.interceptors?.responseSuccessFn) {
            res = config?.interceptors?.responseSuccessFn(res)
          }
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  }

  get<T = any>(config: RequestConfig<T>) {
    return this.request({ ...config, method: 'GET' })
  }

  post<T = any>(config: RequestConfig<T>) {
    return this.request({ ...config, method: 'POST' })
  }

  delete<T = any>(config: RequestConfig<T>) {
    return this.request({ ...config, method: 'DELETE' })
  }

  patch<T = any>(config: RequestConfig<T>) {
    return this.request({ ...config, method: 'PATCH' })
  }

  put<T = any>(config: RequestConfig<T>) {
    return this.request({ ...config, method: 'PUT' })
  }
}

export default MyRequest
